<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header
                :title="$t('return')"
                @back="goBack"
                :content="$t('display_location_detail')"
              ></el-page-header>
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button type="primary" icon="el-icon-check" @click="saveModel"
                >{{ $t("save") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form
          class="type-form"
          :model="edit_model"
          :rules="rules"
          ref="modelForm"
          label-width="auto"
          v-if="isReady"
        >
          <CopyPaste
            :button_status="!!edit_model_id"
            @copyInfo="copyInfo(edit_model)"
            @pasteInfo="pasteInfo"
            ref="copyPaste"
          ></CopyPaste>

          <!-- 位置和状态表单项 -->
          <el-form-item :label="$t('position') + ':'" prop="class_id">
            <el-select
              v-model="edit_model.class_id"
              :placeholder="$t('please_choose')"
              :loading-text="$t('loading') + '...'"
            >
              <el-option
                v-for="item in class_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('status') + ':'">
            <el-select
              v-model="edit_model.status"
              :placeholder="$t('please_choose')"
              :loading-text="$t('loading') + '...'"
            >
              <el-option
                v-for="item in $common.StatusSelectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 标题/副标题/内容 -->
          <el-form-item :label="$t('title') + ':'" prop="title">
            <el-input v-model="edit_model.title" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('subtitle') + ':'">
            <el-input v-model="edit_model.subtitle" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('content') + ':'">
            <el-input v-model="edit_model.msg" clearable></el-input>
          </el-form-item>

          <!-- 跳转类型和内容 -->
          <el-form-item :label="$t('jump_type') + ':'" prop="last_type">
            <el-select
              v-model="edit_model.last_type"
              :placeholder="$t('please_choose')"
              :loading-text="$t('loading') + '...'"
            >
              <el-option
                v-for="item in last_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jump_content') + ':'" prop="last_page">
            <el-input v-model.trim="edit_model.last_page" clearable></el-input>
          </el-form-item>

          <!-- 轮播权重/类型/停止时间 -->
          <el-form-item :label="$t('swiper_weight') + ':'">
            <el-input-number
              v-model="edit_model.number"
              :min="0"
              :label="$t('weight')"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('swiper_type') + ':'" prop="banner_type">
            <el-select
              v-model="edit_model.banner_type"
              :placeholder="$t('please_choose')"
              :loading-text="$t('loading') + '...'"
            >
              <el-option
                v-for="item in banner_type_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('swiper_stop_time') + ':'"
            prop="banner_time"
          >
            <el-input-number
              v-model="edit_model.banner_time"
              :min="0"
              :label="$t('weight')"
            ></el-input-number>
          </el-form-item>
          <el-form-item :label="$t('enable_image_compression') + ':'">
            <el-switch
              v-model="edit_model.compress"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>

          <!-- 图片配置模块 -->
          <el-form
            label-width="auto"
            v-for="device in imageConfig"
            :key="device.name"
            class="form-config"
          >
            <el-form-item :label="device.name + '宽高比'">
              <el-select
                v-model="edit_model[`${device.name}_aspect_ratio_id`]"
                style="min-width: 240px"
                @change="handleAspectRatioChange(device.name)"
              >
                <el-option
                  v-for="item in device.aspectRatioList"
                  :key="item.id"
                  :label="'宽: ' + item.width + ' / ' + '高: ' + item.height"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-for="(config, index) in device.fileList"
              :key="config.type"
              :label="$t(config.label) + ':'"
            >
              <el-input
                v-model="edit_model[config.source]"
                @change="styleInputOnclick(device.name, index)"
                clearable
              ></el-input>
              <div class="gray" v-if="config.sizeTip">
                {{ buildAdviceSize(device) }}
              </div>
              <el-form
                label-width="auto"
                :inline="true"
                :model="config.json.value"
                style="margin-bottom: 10px"
              >
                <el-form-item
                  v-for="dim in config.dimensions"
                  :key="dim"
                  :label="$t(dim) + ':'"
                  style="margin-top: 10px"
                >
                  <el-input-number
                    :value="getJsonField(config.json, dim)"
                    style="width: 150px"
                    controls-position="right"
                    @change="
                      updateJsonField(
                        device.name,
                        index,
                        config.json,
                        dim,
                        $event
                      )
                    "
                  ></el-input-number>
                </el-form-item>
              </el-form>
              <el-input v-model="edit_model[config.style]" disabled></el-input>
              <el-row>
                <el-col :span="12">
                  <el-image
                    :style="
                      'aspect-radio: ' +
                      device.maxDimensions.width +
                      ' / ' +
                      device.maxDimensions.height +
                      ';' +
                      'width: 100%; height: 100%; margin-top: 10px;'
                    "
                    fit="contain"
                    :src="setPreviewImage(device.name, index)"
                    :preview-src-list="[edit_model[config.source]]"
                    lazy
                    @load="handleLoad($event, device.name, index)"
                  ></el-image>
                </el-col>
                <el-col :span="12">
                  <dl style="margin-left: 20px">
                    <dt class="edit-row-dt">
                      <el-button
                        size="mini"
                        type="warning"
                        @click="
                          getImageByWeb(device.name, index, config.source)
                        "
                      >
                        {{ $t("source_choose") }}
                      </el-button>
                    </dt>
                  </dl>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>

          <!-- 视频配置 -->
          <el-form-item :label="$t('pc_video') + ':'">
            <el-input v-model="edit_model.pc_video" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('wap_video') + ':'">
            <el-input v-model="edit_model.wap_video" clearable></el-input>
          </el-form-item>

          <!-- 时间配置 -->
          <el-form-item style="color: #999">{{
            $t("choose_time_tip")
          }}</el-form-item>
          <el-form-item :label="$t('start_display_time') + ':'" prop="start_at">
            <el-date-picker
              v-model="edit_model.start_at"
              type="datetime"
              :placeholder="$t('choose_date_time')"
              default-time="12:00:00"
              align="center"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('end_display_time') + ':'" prop="end_at">
            <el-date-picker
              v-model="edit_model.end_at"
              type="datetime"
              :placeholder="$t('choose_date_time')"
              default-time="12:00:00"
              align="center"
            ></el-date-picker>
          </el-form-item>

          <!-- 预览 -->
          <el-form-item :label="$t('banner_preview') + ':'">
            <a
              :href="
                $common.preview_domain +
                class_path +
                '?copywriter=smok_copywriter'
              "
              target="_blank"
            >
              <el-button
                style="width: 100px; height: 40px"
                type="primary"
                :disabled="!edit_model_id"
                >{{ $t("preview") }}
              </el-button>
            </a>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
    <FileChooseDrawerModule ref="bannerFileChooseDrawerModule" />
  </div>
</template>

<script>
import FileChooseDrawerModule from "../../file/module/FileChooseDrawerModule";
import CopyPaste from "../../../components/CopyPaste.vue";
import { GetCacheKey } from "@/const";

export default {
  name: "BannerDetailView",
  components: {
    FileChooseDrawerModule,
    CopyPaste,
  },
  data() {
    return {
      loading: false,
      rules: this.generateRules(),
      last_type_list: this.generateLastTypeList(),
      banner_type_list: this.generateBannerTypeList(),
      edit_model_id: "",
      edit_model: {
        id: "",
        class_id: "",
        title: "",
        subtitle: "",
        msg: "",
        last_type: 1,
        last_page: "",
        number: 0,
        banner_type: 1,
        banner_time: 5,
        pc_aspect_ratio_id: "",
        wap_aspect_ratio_id: "",
        pc_bg_source: "",
        pc_bg_style: "",
        pc_title_source: "",
        pc_title_style: "",
        pc_info_source: "",
        pc_info_style: "",
        wap_bg_source: "",
        wap_bg_style: "",
        wap_title_source: "",
        wap_title_style: "",
        wap_info_source: "",
        wap_info_style: "",
        pc_video: "",
        wap_video: "",
        start_at: "",
        end_at: "",
        status: 2,
        compress: false,
      },
      pc_bg_json: {},
      pc_title_json: {},
      pc_info_json: {},
      wap_bg_json: {},
      wap_title_json: {},
      wap_info_json: {},
      class_list: [],
      class_path: "",
      jsonTemplates: {
        width: 0,
        height: 0,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
      deviceConfig: {
        pc: {
          aspectRatioId: "",
          sizeTip: "advice_size_pc",
          maxDimensions: { width: 1920, height: 1080 },
        },
        wap: {
          aspectRatioId: "",
          sizeTip: "advice_size_wap",
          maxDimensions: { width: 750, height: 1340 },
        },
      },
      fileListConfig: [
        {
          type: "bg",
          label: "background_image",
          sizeTipKey: "sizeTip",
        },
        {
          type: "title",
          label: "title_image",
        },
        {
          type: "info",
          label: "parameter_image",
        },
      ],
      imageConfig: {},
      isReady: false,
      cacheKey: GetCacheKey("banner"),
    };
  },
  created() {
    this.edit_model_id = this.$route.query.id;
    this.initConfig();

    this.getClassList();
    this.getAspectRatioList();
    if (this.edit_model_id !== undefined && this.edit_model_id.length > 0) {
      this.getEditModel();
    } else {
      this.isReady = true;
    }
  },
  methods: {
    _debounce(func, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
      };
    },

    // 动态生成 rules
    generateRules() {
      const requiredRule = (fieldKey, trigger, message) => ({
        required: true,
        message: this.$t(`${message}`),
        trigger,
      });

      const minRule = (fieldKey, trigger) => ({
        min: 1,
        message: this.$t("size_larger_one_character"),
        trigger,
      });

      return {
        title: [
          requiredRule("title", "blur", "please_enter_title"),
          minRule("title", "blur"),
        ],
        class_id: [
          requiredRule("category", "change", "please_choose_category"),
        ],
        last_type: [
          requiredRule("jump_type", "change", "please_choose_jump_type"),
        ],
        last_page: [
          requiredRule("jump_content", "blur", "please_enter_jump_content"),
          minRule("jump_content", "blur"),
        ],
        banner_type: [
          requiredRule("swiper_type", "change", "please_choose_swiper_type"),
        ],
        banner_time: [
          requiredRule("stop_time", "blur", "please_enter_stop_time"),
        ],
        start_at: [
          requiredRule(
            "start_display_time",
            "blur",
            "please_start_display_time"
          ),
        ],
        end_at: [
          requiredRule("end_display_time", "blur", "please_end_display_time"),
        ],
      };
    },

    // 动态生成 last_type_list
    generateLastTypeList() {
      return [
        { id: 1, name: this.$t("internal_link") },
        { id: 2, name: this.$t("external_link") },
      ];
    },

    // 动态生成 banner_type_list
    generateBannerTypeList() {
      return [
        { id: 1, name: this.$t("image") },
        { id: 2, name: this.$t("image_text") },
        { id: 3, name: this.$t("video") },
      ];
    },

    initConfig() {
      const devices = ["pc", "wap"];
      const indices = [0, 1, 2];
      devices.forEach((device) => {
        this.imageConfig[device] = this.generateDeviceConfig(device);
        indices.forEach((index) => {
          this[`${device}_${this.fileListConfig[index].type}_json`] = {
            ...this.jsonTemplates,
          };
        });
      });
    },

    // 生成设备配置
    generateDeviceConfig(deviceType) {
      if (!this.deviceConfig || !this.deviceConfig[deviceType]) {
        console.error(`Device config for ${deviceType} is not defined`);
        return null;
      }

      const config = this.deviceConfig[deviceType];

      // 添加配置验证
      if (!config || !config.maxDimensions) {
        console.error(`Invalid config for ${deviceType}`);
        return null;
      }

      this.fileListConfig.forEach((item) => {
        this.edit_model[`${deviceType}_${item.type}_source`] = "";
        this.edit_model[`${deviceType}_${item.type}_json`] = "";
        this.edit_model[`${deviceType}_${item.type}_style`] = "";
      });

      return {
        name: deviceType,
        aspectRatioId: "",
        aspectRatioList: [],
        fileList: this.fileListConfig.map((item) => ({
          type: `${deviceType}_${item.type}`,
          label: `${deviceType}_${item.label}`,
          source: `${deviceType}_${item.type}_source`,
          json: `${deviceType}_${item.type}_json`,
          style: `${deviceType}_${item.type}_style`,
          sizeTip: item.sizeTipKey
            ? this.deviceConfig[deviceType][item.sizeTipKey]
            : "",
          dimensions: ["width", "height", "top", "bottom", "left", "right"],
        })),
        maxDimensions: config.maxDimensions,
      };
    },

    getJsonField(jsonKey, dim) {
      return this[jsonKey][dim]; // 安全访问 data 中的字段
    },

    updateJsonField(deviceName, index, jsonKey, dim, value) {
      this[jsonKey][dim] = value;
      this.styleInputOnclick(deviceName, index);
    },

    // 通用宽高比变化处理
    handleAspectRatioChange(deviceName) {
      const device = this.imageConfig[deviceName];
      const aspectRatioId = this.edit_model[`${deviceName}_aspect_ratio_id`];
      const aspectRatio =
        device.aspectRatioList.find((item) => item.id === aspectRatioId) ||
        device.aspectRatioList[0];

      device.maxDimensions = {
        width: aspectRatio.width,
        height: aspectRatio.height,
      };

      device.fileList.forEach((config) => {
        this[config.json] = this.mergeJsonWithDefault(
          this.edit_model[config.json],
          aspectRatio.width
        );

        this.edit_model[config.style] = this.buildPxToPercentage(
          this[config.json],
          aspectRatio.width,
          aspectRatio.height
        );
      });

      [0, 1, 2].forEach((index) => this.styleInputOnclick(deviceName, index));
    },

    // 通用JSON合并方法
    mergeJsonWithDefault(jsonString, defaultWidth) {
      let parsed = {};
      try {
        if (jsonString && jsonString !== "") {
          parsed = JSON.parse(jsonString);
        }
      } catch (e) {
        console.error(`Failed to parse JSON: ${jsonString}`, e);
      }

      return {
        ...JSON.parse(JSON.stringify(this.jsonTemplates)),
        ...parsed,
        width: parsed.width || defaultWidth,
      };
    },

    buildAdviceSize(device) {
      if (!device || !device.fileList) return;
      const maxDimensions = device.maxDimensions;
      return `(建议尺寸: 宽${maxDimensions.width}px; 高:${maxDimensions.height}px)`;
    },

    _fetchBannerData(apiPath, cacheKey, dataHandler) {
      const cached = this.$common.getGlobalStorage(cacheKey);
      if (cached) {
        dataHandler(cached);
        return;
      }

      const params = {
        status: 1,
        page_size: -1,
        page_number: 1,
      };

      this.loading = true;
      this.$common
        .httpPost(`/api/banner/admin/${apiPath}`, params)
        .then((res) => {
          this.loading = false;
          if (res && res.code === "1000000") {
            const data = (res.data && res.data.array) || [];
            if (Array.isArray(data) && data.length > 0) {
              dataHandler(data);
              this.$common.setGlobalStorage(cacheKey, data);
            }
          } else {
            this._showError(res.message);
          }
        })
        .catch((err) => {
          this.loading = false;
          this._showError(err);
        });
    },

    // 统一错误提示
    _showError(message) {
      this.$message({
        message: message || this.$t("fail_obtain_data"),
        type: "error",
      });
    },

    // 优化后的获取分类方法
    getClassList() {
      this._fetchBannerData(
        "class/find/list",
        this.cacheKey.classList,
        (data) => {
          this.class_list = data;
        }
      );
    },

    // 优化后的获取比例方法
    getAspectRatioList() {
      this._fetchBannerData(
        "aspect_ratio/find/list",
        this.cacheKey.aspectRatioList,
        (data) => {
          const [pcList, wapList] = [[], []];
          data.forEach((item) => {
            if (item.platform === 1) pcList.push(item);
            else if (item.platform === 2) wapList.push(item);
          });

          this.imageConfig.pc.aspectRatioList = pcList;
          this.imageConfig.wap.aspectRatioList = wapList;

          // 安全设置默认值
          this.edit_model.pc_aspect_ratio_id =
            pcList.length > 0 ? pcList[0].id : null;
          this.edit_model.wap_aspect_ratio_id =
            wapList.length > 0 ? wapList[0].id : null;
        }
      );
    },

    getEditModel() {
      this.loading = true;
      const params = {
        id: this.edit_model_id,
      };

      this.$common
        .httpPost("/api/banner/admin/find/id", params)
        .then((res) => {
          this.loading = false;
          if (res && res.code === "1000000") {
            this.edit_model = res.data;

            // 设置 class_path
            const targetClass = this.class_list.find(
              (item) => item.id === this.edit_model.class_id
            );
            this.class_path =
              targetClass && targetClass.alias === "product"
                ? "/" + targetClass.alias
                : "";

            // 动态绑定 JSON 字段
            for (let device in this.imageConfig) {
              this.handleAspectRatioChange(device);
            }

            this.isReady = true;
          } else {
            this.$message({
              message: res.message || this.$t("fail_obtain_data"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            message: err || this.$t("fail_obtain_data"),
            type: "error",
          });
        });
    },

    getImageByWeb(deviceName, index, imageType) {
      this.$refs.bannerFileChooseDrawerModule.showChooseDrawer(
        (chooseFileList) => {
          if (
            chooseFileList.length > 0 &&
            chooseFileList[0] &&
            chooseFileList[0].file_url
          ) {
            this.edit_model[imageType] = chooseFileList[0].file_url;
            this.styleInputOnclick(deviceName, index);
          }
        }
      );
    },

    // 通用样式输入处理
    styleInputOnclick(deviceName, index) {
      const config = this.imageConfig[deviceName].fileList[index];
      if (!config) return;

      const { source, json, style } = config;
      const maxDimensions = this.imageConfig[deviceName].maxDimensions;

      if (!this.edit_model || !this.edit_model[source]) {
        this[json] = { ...this.jsonTemplates };
      }

      if (!this[json]) {
        this[json] = { ...this.jsonTemplates, width: maxDimensions.width };
      }

      this.edit_model[json] = JSON.stringify(this[json]);
      this.edit_model[style] = this.buildPxToPercentage(
        this[json],
        maxDimensions.width,
        maxDimensions.height
      );
    },

    setPreviewImage(deviceName, index) {
      const config = this.imageConfig[deviceName].fileList[index];
      if (!config) return;
      const { source, json } = config;

      if (!this.edit_model[source]) {
        return "";
      }

      // 检查图片宽度是否已设置
      if (!this[json] || !this[json].width) {
        return this.edit_model[source];
      } else {
        return (
          this.edit_model[source] + this.$common.K_QINIU_IMAGE_SMALL_END_200
        );
      }
    },

    handleLoad(e, deviceName, index) {
      const img = e.target;
      const src = img.src;
      if (src.endsWith(this.$common.K_QINIU_IMAGE_SMALL_END_200)) {
        return;
      }

      const config = this.imageConfig[deviceName].fileList[index];
      if (!config) return;

      const onceLoad = () => {
        // 移除监听器
        img.onload = null;

        if (img.naturalWidth > 0) {
          this.handleImageLoad(
            img,
            config.json,
            config.style,
            this.imageConfig[deviceName].maxDimensions
          );
        }
      };

      if (img.complete && img.naturalWidth > 0) {
        onceLoad();
      } else {
        img.onload = onceLoad;
      }
    },

    // 提取公共处理逻辑
    handleImageLoad(img, json, style, maxDimensions) {
      try {
        if (img.naturalWidth > 0 && img.naturalWidth !== this[json].width) {
          this[json].width = img.naturalWidth;
          this.edit_model[json] = JSON.stringify(this[json]);
          this.edit_model[style] = this.buildPxToPercentage(
            this[json],
            maxDimensions.width,
            maxDimensions.height
          );
        }
      } catch (error) {
        console.error("Error during image load:", error);
      }
    },

    buildPxToPercentage(model, maxWidth, maxHeight) {
      return this.buildStyle(
        model,
        {
          width: maxWidth / 100,
          height: maxHeight / 100,
          top: maxHeight / 100,
          bottom: maxHeight / 100,
          left: maxWidth / 100,
          right: maxWidth / 100,
        },
        "%"
      );
    },

    buildStyle(model, divisor, unit) {
      if (!model || typeof model !== "object") {
        console.error("Invalid input: model must be an object.");
        return "";
      }

      divisor = divisor || {
        width: 1,
        height: 1,
        top: 1,
        bottom: 1,
        left: 1,
        right: 1,
      };
      const properties = ["width", "height", "top", "bottom", "left", "right"];
      const styleParts = [];

      properties.forEach((prop) => {
        if (
          model[prop] !== undefined &&
          typeof model[prop] === "number" &&
          model[prop] !== 0
        ) {
          let value;
          if (typeof divisor === "number") {
            value = model[prop] / divisor;
          } else if (
            typeof divisor === "object" &&
            divisor[prop] !== undefined
          ) {
            value = model[prop] / divisor[prop];
          } else {
            console.warn(`No divisor defined for property "${prop}".`);
            return;
          }
          // 使用模板字符串优化拼接
          styleParts.push(`${prop}:${value.toFixed(1)}${unit}`);
        }
      });

      return styleParts.join(";") + ";";
    },

    saveModel() {
      this.$refs["modelForm"].validate((valid) => {
        // 强制类型转换
        if (valid !== true) {
          this.$message({
            message: this.$t("please_check_list"),
            type: "error",
          });
          return;
        }

        // 防抖执行保存操作
        this._debounce(() => {
          const devices = ["pc", "wap"];
          const indices = [0, 1, 2];
          devices.forEach((device) => {
            indices.forEach((index) => {
              this.styleInputOnclick(device, index);
            });
          });

          this._submitForm();
        }, 300)();
      });
    },

    _submitForm() {
      if (this.edit_model_id !== undefined && this.edit_model_id.length > 0) {
        this.updateModel();
      } else {
        this.addModel();
      }
    },

    addModel() {
      const { start_time, end_time } = this.getDefaultTimeRange();
      this.setStartAndEndAt(start_time, end_time);

      if (!this.validateTimeRange()) return;

      const params = this.buildParams();
      this.submitRequest(
        "/api/banner/admin/add",
        params,
        this.$t("content_add_success")
      );
    },

    updateModel() {
      if (!this.validateTimeRange()) return;

      const params = this.buildParams(true);
      this.submitRequest(
        "/api/banner/admin/update",
        params,
        this.$t("content_save_success")
      );
    },

    getDefaultTimeRange() {
      const start_time = this.$common.formatTimesToTime(new Date());
      const end_time = this.$common.getNextMonth(start_time);
      return { start_time, end_time };
    },

    setStartAndEndAt(start_time, end_time) {
      if (!this.edit_model.start_at) {
        this.edit_model.start_at = start_time;
      }
      if (!this.edit_model.end_at) {
        this.edit_model.end_at = end_time;
      }
    },

    validateTimeRange() {
      const begin = new Date(this.edit_model.start_at);
      const end = new Date(this.edit_model.end_at);

      if (begin && end && begin.getTime() > end.getTime()) {
        this.$message({
          message: this.$t("start_time_cannot_greater_end_time"),
          type: "error",
        });
        return false;
      }

      return true;
    },

    buildParams(isUpdate = false) {
      const commonParams = {
        class_id: this.edit_model.class_id,
        title: this.edit_model.title,
        subtitle: this.edit_model.subtitle,
        msg: this.edit_model.msg,
        last_type: this.edit_model.last_type,
        last_page: this.edit_model.last_page,
        number: this.edit_model.number,
        banner_type: this.edit_model.banner_type,
        banner_time: this.edit_model.banner_time,
        pc_aspect_ratio_id: this.edit_model.pc_aspect_ratio_id,
        wap_aspect_ratio_id: this.edit_model.wap_aspect_ratio_id,
        pc_video: this.edit_model.pc_video,
        wap_video: this.edit_model.wap_video,
        start_at: this.$common.formatTime(this.edit_model.start_at, 0),
        end_at: this.$common.formatTime(this.edit_model.end_at, 0),
        status: this.edit_model.status,
      };

      const deviceParams = ["pc", "wap"].reduce((acc, device) => {
        this.imageConfig[device].fileList.forEach((config) => {
          acc[config.source] = this.edit_model[config.source];
          acc[config.style] = this.edit_model[config.style];
          acc[config.json] = this.edit_model[config.json];
        });
        return acc;
      }, {});

      return isUpdate
        ? {
            ...commonParams,
            ...deviceParams,
            id: this.edit_model.id,
            compress: this.edit_model.compress,
          }
        : { ...commonParams, ...deviceParams };
    },

    submitRequest(apiUrl, params, successMessage) {
      this.loading = true;
      this.$common
        .httpPost(apiUrl, params)
        .then((res) => {
          this.loading = false;
          if (res.code === "1000000") {
            this.$message.success(successMessage);
            this.goBack();
          } else {
            this.$message({
              message: res.message || this.$t("fail_obtain_data"),
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            message: err || this.$t("fail_obtain_data"),
            type: "error",
          });
        });
    },

    goBack() {
      // 返回上一级路由
      this.$router.go(-1);
    },

    // 复制信息
    copyInfo(str) {
      // 触发赋值事件，将当前的数据传值
      this.$refs.copyPaste.CopyInfo(str);
    },

    // 粘贴信息
    pasteInfo(model) {
      // 接受粘贴事件的传值数据
      this.edit_model = model;
      this.edit_model.id = this.edit_model_id;
      if (model.pc_bg_json) {
        this.pc_bg_json = JSON.parse(model.pc_bg_json);
      }
      if (model.pc_title_json) {
        this.pc_title_json = JSON.parse(model.pc_title_json);
      }
      if (model.pc_info_json) {
        this.pc_info_json = JSON.parse(model.pc_info_json);
      }
      if (model.wap_bg_json) {
        this.wap_bg_json = JSON.parse(model.wap_bg_json);
      }
      if (model.wap_title_json) {
        this.wap_title_json = JSON.parse(model.wap_title_json);
      }
      if (model.wap_info_json) {
        this.wap_info_json = JSON.parse(model.wap_info_json);
      }

      this.class_list.forEach((item) => {
        if (item.id == model.class_id) {
          this.edit_model.class_id = item.id;
        }
      });
    },
  },
  mounted() {
    console.log(this.$t("save"));
  },
};
</script>

<style scoped>
.edit-form {
  min-width: 800px;
  max-width: 800px;
}

.form-config {
  border: 1px dashed #999999;
  padding: 20px 20px;
  margin-bottom: 30px;
}
</style>
